import { colorSceneDark, colorSceneLight, commonBase, } from '@kid/Kwai_LA-color/color/output/common/index';
export { commonBase } from '@kid/Kwai_LA-color/color/output/common/index';
export const light = Object.assign(Object.assign({}, commonBase), colorSceneLight);
export const dark = Object.assign(Object.assign({}, commonBase), colorSceneDark);
